import { render, staticRenderFns } from "./PageInvoices.vue?vue&type=template&id=601c04b0&"
import script from "./PageInvoices.vue?vue&type=script&lang=js&"
export * from "./PageInvoices.vue?vue&type=script&lang=js&"
import style0 from "./PageInvoices.vue?vue&type=style&index=0&id=601c04b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports